// frontend/src/components/SEO/GlobalSEO.jsx
import { Helmet } from 'react-helmet-async';
import { useSEO } from '../../context/SEOContext';

export const GlobalSEO = () => {
  const { seo, hasCustomSEO } = useSEO();
  
  // اگر صفحه سئوی اختصاصی دارد، متای عمومی را نمایش نده
  if (hasCustomSEO || !seo) return null;
  
  const currentUrl = window.location.href;
  
  return (
    <Helmet>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      
      {/* Open Graph */}
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="سان ایران" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      
      {/* Robots */}
      {seo.noindex && <meta name="robots" content="noindex, nofollow" />}
      
      {/* Canonical */}
      <link rel="canonical" href={currentUrl} />
    </Helmet>
  );
};